import React, { useState, useMemo, useCallback } from 'preact/compat';
import propTypes from 'prop-types';

import { renderComponent } from './Utils';

/*

Issue
-----

Cannot use single component because importing an existing component
that uses React.createElement as JSX pragma, will not work with
Preact.h JSX pragma.

Normally this is solved by module alias for "react" to "preact"
in Webpack/Babel, but since we are using CRA(P) and we are not ejected,
we are out of luck.

Solution
--------

Preact is able to replace React, so using Preact for SSR is also a way.
This is the prefered way.

Another solution
-----------------

If client-side scripts are built by separate Webpack config/entry,
alias can be there.


*/

// IGNORE THIS
const Icon = ({ name }) => (
  <svg className={`icon icon--${name}`} role="presentation" aria-hidden="true">
    <use xlinkHref={`/sprite.svg#${name}`} />
  </svg>
);
Icon.propTypes = {
  name: propTypes.string,
};
// IGNORE UNTIL HERE

const FooterEasterEgg = () => {
  const content = useMemo(
    () => [
      <span style={{}}>
        &nbsp;<Icon name="asterisk" />
      </span>,
      '☕',
      '👍',
      '👀',
      '☝️',
      <span>
        We love your curiosity!{' '}
        <span style={{ color: '#c51104' }}>
          <Icon name="heart" />
        </span>
      </span>,
    ],
    []
  );

  const [index, setIndex] = useState(0);
  const onClick = useCallback(() => setIndex((index + 1) % content.length));

  return (
    <div
      role="presentation"
      onClick={onClick}
      className="text-color-white"
      style={{
        outline: 'none',
        userSelect: 'none',
        cursor: 'pointer',
        textAlign: 'right',
      }}
    >
      <span>{content[index]}</span>
    </div>
  );
};

export default renderComponent(FooterEasterEgg, '#footer-easter-egg');



// WEBPACK FOOTER //
// ./src/scripts/modules/FooterEasterEgg.js